var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElPencilAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0ZM11.3597 2.65517C11.6089 2.65714 11.8508 2.74906 12.0336 2.93183L13.4481 4.34581C13.8391 4.73682 13.8123 5.39562 13.3894 5.81953C12.9655 6.24346 12.3056 6.26867 11.9157 5.87874L10.5017 4.46477C10.1107 4.07483 10.1381 3.41393 10.5609 2.99105C10.7856 2.76582 11.0773 2.65295 11.3597 2.65517ZM9.0291 4.52343L11.8576 7.35138L7.26096 11.9469L4.43247 9.11845L9.0291 4.52343ZM3.69829 9.654L6.68179 12.6375L2.95121 13.3846L3.69829 9.654Z",
    fill: "#7A934F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElPencilAlt);
export default __webpack_public_path__ + "static/media/el_pencil-alt.6b88bbb308d3be232853f57ab86aea9e.svg";
export { ForwardRef as ReactComponent };